var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "msa-container" }, [
    _c(
      "div",
      { ref: "msaWrapper", staticClass: "msa-wrapper" },
      _vm._l(_vm.blockRanges, function ([start, end], i) {
        return _c("div", { staticClass: "msa-block-wrapper" }, [
          _c(
            "div",
            {
              staticClass: "msa-block",
              on: {
                mousemove: function ($event) {
                  return _vm.onBlockMouseMove($event, start, end)
                },
                mouseleave: _vm.onBlockMouseLeave,
                click: function ($event) {
                  return _vm.onBlockClick($event, start, end)
                },
              },
            },
            [
              _c("span", { staticClass: "conservation-label" }, [
                _vm._v("Conservation"),
              ]),
              _vm._v(" "),
              _c(
                "svg",
                {
                  staticClass: "conservation-track",
                  style: {
                    gridColumn: 2,
                    gridRow: 1,
                    width: "calc((1ch + 4px) * " + String(end - start) + ")",
                    height: _vm.conservationHeight + "px",
                    transform: "translateX(-2px)",
                  },
                  attrs: {
                    viewBox: `0 0 ${end - start} ${_vm.conservationHeight}`,
                    preserveAspectRatio: "none",
                  },
                },
                [
                  _c("path", { attrs: { d: _vm.conservationBlocks[i].path } }),
                  _vm._v(" "),
                  _c(
                    "g",
                    {
                      attrs: {
                        transform: `scale(${1 / _vm.conservationScaleX}, 1)`,
                      },
                    },
                    _vm._l(_vm.conservationBlocks[i].maxCols, function (idx) {
                      return _c(
                        "text",
                        {
                          key: `cons-max-${i}-${idx}`,
                          staticClass: "conservation-max",
                          attrs: {
                            x: (idx + 0.5) * _vm.conservationScaleX,
                            y: "0",
                            "text-anchor": "middle",
                            "dominant-baseline": "hanging",
                          },
                        },
                        [_vm._v("*")]
                      )
                    }),
                    0
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.alnLen === 0
                ? _c(
                    "div",
                    {
                      staticClass: "all-masked-overlay",
                      style: {
                        gridColumn: "2",
                        gridRow: `2 / ${_vm.entries.length + 2}`,
                      },
                    },
                    [_vm._v("All sequences are masked")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(
                _vm.cachedEntryRanges[i],
                function ({ name, aa, ss, seqStart, css }, j) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "header",
                        style: _vm.headerStyle(j),
                        attrs: { title: name },
                        on: {
                          click: function ($event) {
                            return _vm.handleClickHeader($event, j)
                          },
                        },
                      },
                      [_vm._v(_vm._s(name))]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "sequence-wrapper",
                        style: _vm.sequenceStyle(j),
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "sequence",
                            style:
                              _vm.alnLen > 0
                                ? [
                                    css,
                                    {
                                      color: _vm.sequenceColor,
                                      "font-weight": _vm.fontWeight,
                                    },
                                  ]
                                : {},
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.alnLen > 0
                                  ? _vm.alphabet == "aa"
                                    ? aa
                                    : ss
                                  : ""
                              )
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    j == 0
                      ? _c(
                          "div",
                          {
                            staticClass: "column-wrapper",
                            style: _vm.overlayStyle(aa.length),
                          },
                          [
                            _vm._l(
                              _vm.getBlockHighlights(start, end),
                              function (idx) {
                                return _c("div", {
                                  key: `sel-${i}-${idx}`,
                                  staticClass: "column-marker column-active",
                                  style: _vm.columnMarkerStyle(
                                    idx,
                                    end - start
                                  ),
                                })
                              }
                            ),
                            _vm._v(" "),
                            _vm.getHoverLocalIndex(start, end) !== null
                              ? _c("div", {
                                  staticClass: "column-marker column-hover",
                                  style: _vm.columnMarkerStyle(
                                    _vm.getHoverLocalIndex(start, end),
                                    end - start
                                  ),
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.getPreviewLocalIndex(start, end) !== null
                              ? _c("div", {
                                  staticClass: "column-marker column-preview",
                                  style: _vm.columnMarkerStyle(
                                    _vm.getPreviewLocalIndex(start, end),
                                    end - start
                                  ),
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hoverInfo &&
                            _vm.hoverInfo.start === start &&
                            _vm.hoverInfo.rowIndex !== null
                              ? _c("div", {
                                  staticClass: "residue-hover",
                                  style: _vm.residueMarkerStyle(
                                    _vm.hoverInfo,
                                    end - start
                                  ),
                                })
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "count", style: _vm.countStyle(j) },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.alnLen > 0
                              ? _vm.countSequence(aa, seqStart)
                              : ""
                          )
                        ),
                      ]
                    ),
                  ]
                }
              ),
            ],
            2
          ),
        ])
      }),
      0
    ),
    _vm._v(" "),
    _vm.hoverInfo
      ? _c(
          "div",
          {
            staticClass: "column-tooltip",
            style: _vm.tooltipStyle(_vm.hoverInfo),
          },
          [
            _c("pre", { staticClass: "column-tooltip-text" }, [
              _vm._v(_vm._s(_vm.getHoverTooltipText(_vm.hoverInfo))),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }